// src/components/RestaurantsProvider.tsx
import React from 'react';
import { HimmaContext } from '../context/HimmaContext';
import { createHimmaClient } from '../context/Auth/AuthenticatedApiClient';

type HimmaProviderProps = {
  children: React.ReactNode;
  baseUrl: string;
};

export const HimmaProvider: React.FC<HimmaProviderProps> = ({
  children,
  baseUrl,
}) => {
  const HimmaClient = createHimmaClient(baseUrl);

  return (
    <HimmaContext.Provider value={HimmaClient}>
      {children}
    </HimmaContext.Provider>
  );
};
